module.exports = __webpack_public_path__ + "static/media/twitter.182d5ef4.svg";